// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xONw8","postfix":"styles_postfix__0j8LF","prefix":"styles_prefix__ctb6h"};